<div class="bp-modal mod-lg">
  <bp-modal-header [title]="'verification_onfido_failed_modal_title' | translate">
    <a right (click)="onCloseClick()" (keydown.enter)="onCloseClick()" [tabIndex]="0">
      <strong>{{ "close" | translate }}</strong>
    </a>
  </bp-modal-header>
  <div class="bp-modal-body verification-modal">
    <div class="bp-modal-body-section">
      <div class="failed_screen__image_wrapper">
        <div class="failed_screen__image_container">
          <img src="assets/images/sad-smiley.svg" [alt]="'not_supported_browser_alt_text' | translate" />
        </div>
      </div>
      <div class="failed_screen__container">
        <div class="failed_screen__title">{{ getHeaderTitle() | translate }}</div>
        <div class="failed_screen__subtitle">{{ getDescription() | translate }}</div>
        @if (showDocumentListUrl()) {
          <div class="failed_screen__link">
            <a [href]="getSupportedDocumentsLink()" [target]="'_blank'" [tabIndex]="0">
              {{ "verification_onfido_failed_documents_list" | translate }}
            </a>
          </div>
        }
      </div>
      <button class="btn btn-primary mod-button-width" (click)="onButtonClick()" [tabIndex]="0">
        {{ getButtonText() | translate }}
      </button>
    </div>
  </div>
</div>
